import React from 'react'
import BuyerCreateProposalPage from '../buyer/create-proposal/create-proposal-page.tsx'
import BuyerProposalDetailPage from '../buyer/proposal-detail/proposal-detail-page.tsx'
import BuyerProposalOverviewPage from '../buyer/proposal-overview/proposal-overview-page.tsx'
import {
  AppNavMenu,
  AppNavMenuGroup,
  AppNavMenuItem,
} from '../../lib/southfork/components'
import { UserType } from '../../api/auth-api'
import IssuerProposalDetailPage from '../issuer/proposal-detail/proposal-detail-page.tsx'
import IssuerProposalOverviewPage from '../issuer/proposal-overview/proposal-overview-page.tsx'
export interface Page {
  title: string
  path: string
  routerPath?: string //used for react-router, when you need sub-paths under the
  component: (() => React.JSX.Element) | React.FC<object>
}

/**
 * Define all top-level pages, including the path routes, here
 * If the page needs to handle sub-paths
 *   - use routerPath with /* (e.g. path=/my-page/*)
 *   - sub-pages, e.g. with SFPageNav, are defined _within_ the top-level page, and append their path to the top-level path
 */

export const BUYER_PAGES = {
  PROPOSALS: {
    title: 'Proposals',
    path: '/proposals',
    component: BuyerProposalOverviewPage,
  },
  PROPOSAL_DETAIL: {
    title: 'Proposal Detail',
    path: '/proposals/item/:id',
    component: BuyerProposalDetailPage,
  },
  CREATE_PROPOSAL: {
    title: 'Create Proposal',
    path: '/proposals/new',
    component: BuyerCreateProposalPage,
  },
}

export const ISSUER_PAGES = {
  PROPOSALS: {
    title: 'Proposals',
    path: '/proposals',
    component: IssuerProposalOverviewPage,
  },
  PROPOSAL_DETAIL: {
    title: 'Proposal Detail',
    path: '/proposals/item/:id',
    component: IssuerProposalDetailPage,
  },
}

const buyerNavItems: (AppNavMenuGroup | AppNavMenuItem)[] = [
  // By convention, the first page is the home page
  {
    title: BUYER_PAGES.PROPOSALS.title,
    path: BUYER_PAGES.PROPOSALS.path,
  },
]

const issuerNavItems: (AppNavMenuGroup | AppNavMenuItem)[] = [
  {
    title: ISSUER_PAGES.PROPOSALS.title,
    path: ISSUER_PAGES.PROPOSALS.path,
  },
]

export function getPages(userType: UserType | null): Page[] {
  if (!userType) {
    return []
  }

  switch (userType) {
    case UserType.BUYER:
      return Object.values(BUYER_PAGES)
    case UserType.ISSUER:
      return Object.values(ISSUER_PAGES)
    default:
      return []
  }
}

export function getBuyerPages(): Page[] {
  return Object.values(BUYER_PAGES)
}

export function getIssuerPages(): Page[] {
  return Object.values(ISSUER_PAGES)
}

export function getAppNavMenu(userType: UserType | null): AppNavMenu {
  if (!userType) {
    return { items: [] }
  }

  switch (userType) {
    case UserType.BUYER:
      return { items: buyerNavItems }
    case UserType.ISSUER:
      return { items: issuerNavItems }
    default:
      return { items: [] }
  }
}
